// 本地 mock 数据，后端接口就绪后由 api 模块替换
export const semanticMap = {
  '拍照|摄影|拍摄|相机|照片|相册|拍照结合': ['K002'],
  '设备|安全帽|头盔|硬件|d6|开机|电源|充电|电池|怎么用设备': ['K001'],
  '平台|系统|操作|登录|入口|挂载|嵌入|aicaps': ['K003'],
  'ai|智能|识别|增强|自动|解读|人工智能': ['K002'],
  '文档|上传|知识库|导出|文章|录入': ['K002', 'K003'],
  '说明|指南|使用方法|操作指南': ['K001', 'K003']
}

export function createInitialState() {
  return {
    knowledge: [
      {
        id: 'K001',
        title: '如何使用 D6 设备',
        purpose: '设备使用说明',
        content: '<p>D6 设备开机后长按电源键 3 秒，进入主界面后选择「拍摄」模式即可拍照。结合 AI 功能可在相册中一键生成说明文案。</p><table><tr><th>场景</th><th>操作</th></tr><tr><td>日常巡检</td><td>佩戴后开机，确认指示灯蓝色常亮</td></tr><tr><td>拍照记录</td><td>主界面点「拍摄」，AI 自动生成说明</td></tr></table>',
        status: 'published',
        creator: 'creator',
        tags: ['D6']
      },
      {
        id: 'K002',
        title: '如何拍照结合 AI',
        purpose: '功能说明',
        content: '在拍摄界面点击「AI 增强」，系统会自动识别画面内容并生成图文解读，支持导出到知识库文章。',
        status: 'published',
        creator: 'creator',
        tags: ['技术文章']
      },
      {
        id: 'K003',
        title: 'AICAPS 平台操作指南',
        purpose: '平台操作',
        content: '登录 AICAPS 后，在「我的应用」中找到 FAQ 助手入口，点击右下角图标即可发起问答。',
        status: 'published',
        creator: 'creator',
        tags: ['运维手册', '技术文章']
      },
      {
        id: 'K004',
        title: '6816 旧版固件升级说明',
        purpose: '运维手册',
        content: '本文为 6816 设备 V1.2 固件升级步骤说明，当前已停止维护，请参考最新版手册。',
        status: 'disabled',
        creator: 'admin',
        tags: ['6816']
      },
      {
        id: 'K005',
        title: 'D6 智能安全帽佩戴规范（草稿）',
        purpose: '帽子使用说明',
        status: 'draft',
        creator: 'creator',
        tags: ['帽子使用说明'],
        content: '<h3>安全帽佩戴规范</h3><p>以下为 D6 智能安全帽日常佩戴与巡检要点：</p>'
      }
    ],
    presets: [
      { q: '如何使用 D6 设备？', on: true },
      { q: '如何拍照结合 AI？', on: true },
      { q: 'AICAPS 平台怎么操作？', on: true },
      { q: '客户常见问题有哪些？', on: false }
    ],
    userFeedback: [],
    online: true
  }
}

export function stripHtml(s) {
  const d = document.createElement('div')
  d.innerHTML = s || ''
  return (d.textContent || '').replace(/\s+/g, ' ').trim()
}

/** 知识库卡片摘要：去除 Markdown/图片/base64，并截断 */
export function formatExcerpt(text, maxLen = 120) {
  if (!text) return ''
  let s = String(text)
  s = s.replace(/!\[[^\]]*\]\([^)]+\)/g, '[图片]')
  s = s.replace(/data:image\/[^)\s'"<>]+/gi, '[图片]')
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1')
  s = s.replace(/\*([^*]+)\*/g, '$1')
  s = s.replace(/__([^_]+)__/g, '$1')
  s = s.replace(/_([^_]+)_/g, '$1')
  s = s.replace(/`([^`]+)`/g, '$1')
  s = s.replace(/\|/g, ' ')
  s = s.replace(/-{3,}/g, ' ')
  s = s.replace(/#{1,6}\s*/g, '')
  s = stripHtml(s)
  s = s.replace(/\s+/g, ' ').trim()
  if (s.length > maxLen) s = s.slice(0, maxLen)
  return s
}

export function hybridSearch(knowledge, query) {
  const q = (query || '').toLowerCase().trim()
  const pub = knowledge.filter(k => k.status === 'published')
  if (!q) return pub.map(k => ({ ...k, _matchType: 'all' }))

  const kwIds = {}
  const kwHits = pub.filter(k => {
    const hit = k.title.toLowerCase().includes(q) ||
      (k.content || '').toLowerCase().includes(q)
    if (hit) kwIds[k.id] = true
    return hit
  }).map(k => ({ ...k, _matchType: 'keyword' }))

  const semIds = {}
  Object.keys(semanticMap).forEach(keywords => {
    const kws = keywords.split('|')
    const matched = kws.some(kw => q.includes(kw))
    if (matched) semanticMap[keywords].forEach(id => { semIds[id] = true })
  })

  const semHits = pub.filter(k => semIds[k.id] && !kwIds[k.id])
    .map(k => ({ ...k, _matchType: 'semantic' }))

  return kwHits.concat(semHits)
}

export function delay(ms = 200) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
